import { StablecoinDestinationCreate } from '../../models/destination.model';
import { StablecoinApprovalDecisionValue, StablecoinTransferCreate } from '../../models/transfer.model';
import { StablecoinActivityFilter } from '../../models/report.model';

export class InitStablecoinTransfersState {
	static readonly type: string = '[StablecoinTransfers] InitStablecoinTransfersState';
}

export class ClearStablecoinTransfersState {
	static readonly type: string = '[StablecoinTransfers] ClearStablecoinTransfersState';
}

export class ResetStablecoinTransfersState {
	static readonly type: string = '[StablecoinTransfers] ResetStablecoinTransfersState';
}

export class GetStablecoinTransfers {
	static readonly type: string = '[StablecoinTransfers] GetStablecoinTransfers';
	constructor(
		public filter?: StablecoinActivityFilter,
		public cursor?: string
	) {}
}

export class GetNeedsApprovalTransfers {
	static readonly type: string = '[StablecoinTransfers] GetNeedsApprovalTransfers';
}

export class CreateStablecoinTransfer {
	static readonly type: string = '[StablecoinTransfers] CreateStablecoinTransfer';
	constructor(
		public body: StablecoinTransferCreate,
		public idempotencyKey: string
	) {}
}

export class CancelStablecoinTransfer {
	static readonly type: string = '[StablecoinTransfers] CancelStablecoinTransfer';
	constructor(public transferId: string) {}
}

export class GetTransferApprovals {
	static readonly type: string = '[StablecoinTransfers] GetTransferApprovals';
	constructor(public transferId: string) {}
}

export class SubmitTransferApproval {
	static readonly type: string = '[StablecoinTransfers] SubmitTransferApproval';
	constructor(
		public transferId: string,
		public decision: StablecoinApprovalDecisionValue,
		public comment?: string
	) {}
}

export class GetStablecoinDestinations {
	static readonly type: string = '[StablecoinTransfers] GetStablecoinDestinations';
}

export class CreateStablecoinDestination {
	static readonly type: string = '[StablecoinTransfers] CreateStablecoinDestination';
	constructor(public body: StablecoinDestinationCreate) {}
}

export class SubmitDestinationApproval {
	static readonly type: string = '[StablecoinTransfers] SubmitDestinationApproval';
	constructor(
		public destinationId: string,
		public decision: StablecoinApprovalDecisionValue,
		public comment?: string
	) {}
}

export class DisableStablecoinDestination {
	static readonly type: string = '[StablecoinTransfers] DisableStablecoinDestination';
	constructor(public destinationId: string) {}
}

export class GetStablecoinApprovalPolicy {
	static readonly type: string = '[StablecoinTransfers] GetStablecoinApprovalPolicy';
}
